import { SET_VERSION_INFO } from "../actions/types";

const initialState = {
  isForge: undefined,
  hasLoaded: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_VERSION_INFO:
      return {
        ...state,
        ...action.payload,
        hasLoaded: true,
      };
    default:
      return state;
  }
}
